export const wishlistActions = {
    FETCH_WISHLIST: 'FETCH_WISHLIST',
    SAVE_WISHLIST: 'SAVE_WISHLIST',
};
